import { createAction } from 'redux-actions'
import Api from '../Api'

import { setAlert } from './alerts'

export const REQUEST_USER_SESSION = createAction('REQUEST_USER_SESSION')
export const RECEIVE_USER_SESSION = createAction('RECEIVE_USER_SESSION', session => session)
export const CHECK_USER_SESSION= createAction('CHECK_USER_SESSION', session => session)
export const REMOVE_USER_SESSION = createAction('REMOVE_USER_SESSION')
export const RECEIVE_USER_REQUEST_INFO = createAction('RECEIVE_USER_REQUEST_INFO')
export const REGISTER_USER = createAction('REGISTER_USER', session => session)
export const VERIFY_USER_EMAIL = createAction('VERIFY_USER_EMAIL')
export const REQUEST_USER_DATA = createAction('REQUEST_USER_DATA')
export const RECEIVE_USER_DATA = createAction('RECEIVE_USER_DATA', session => session)

export const setUserSession = (username, password) => {
  return (dispatch) => {
    dispatch(REQUEST_USER_SESSION())

    return Api.login(username, password)
      .then(response => dispatch(RECEIVE_USER_SESSION({data: response.data})))
      .catch(error => {
        dispatch(RECEIVE_USER_SESSION({data: error.response.data}))
        dispatch(setAlert(error.response.data.message, undefined, 'error'))
      })
  }
}

export const checkUserSession = () => {
  return (dispatch) => {
    dispatch(CHECK_USER_SESSION({
      data: {
        token: Api.getToken()
      }
    }))
  }
}

export const removeUserSession = (error = true) => {
  Api.logout()

  return (dispatch) => {
    dispatch(REMOVE_USER_SESSION({
      error: error
    }))
  }
}

export const getUserRequestInfo = (joinCode) => {
  return (dispatch) => {
    return Api.getUserRequestInfo(joinCode)
      .then(response => dispatch(RECEIVE_USER_REQUEST_INFO({data: response.data})))
      .catch(error => dispatch(RECEIVE_USER_REQUEST_INFO(error.response)))
  }
}

export const userRegister = (user, requestCode) => {
  return (dispatch) => {
    return dispatch(REGISTER_USER(Api.register(user, requestCode)))
  }
}

export const verifyUserEmail = (code) => {
  return (dispatch) => {
    return Api.verifyUserEmail(code)
      .then(response => dispatch(VERIFY_USER_EMAIL({data: response.data})))
      .catch(error => dispatch(VERIFY_USER_EMAIL(error.response)))
  }
}

export const getUserData = () => {
  return (dispatch) => {
    dispatch(REQUEST_USER_DATA())

    return dispatch(RECEIVE_USER_DATA(Api.getUserData()))
  }
}



// WEBPACK FOOTER //
// ./src/actions/user-session.js